import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormInputsProps } from '../types';
import { generateSelectOptionsForFormGenerator } from '../utils/generateSelectOptions';
import { useTranslation } from 'react-i18next';

export const FormSelect: FC<FormInputsProps> = ({ field }) => {
  const selectOptions = generateSelectOptionsForFormGenerator(field);
  const {
    register,
    formState: { errors }
  } = useFormContext();
  const { title, name, toShow } = field;
  const { t } = useTranslation();

  // TODO пока забили на этот компонент, потом проверить его работу и поправить стили

  return (
    <div className="flex flex-col justify-between h-full items-start gap-2 w-[100%]">
      {title && (
        <label className="text-base pl-[20px] w-full text-left text-i_label">{field.title}</label>
      )}
      <select
        {...register(name, { required: { value: toShow, message: 'validation.valueRequired' } })}
        name={name}
        className="w-full border-solid no-underline rounded-[20px] px-2.5 py-[6.5px] border outline-none">
        {selectOptions.map((option) => (
          <option key={option[0]} value={option[0]}>
            {option[1]}
          </option>
        ))}
      </select>
      {errors[name]?.message && (
        <span className="text-map_error text-xs">{t(errors[name]?.message as string)}</span>
      )}
    </div>
  );
};
